import { useEmployerReactivationBankListModalsStore } from '@/modules/employer/components/EmployerReactivation/EmployerReactivationBankList/stores/useEmployerReactivationBankListModals.store';

import useEmployerReactivationBankList from './useEmployerReactivationBankList';

export const useEmployerReactivationBankListData = () => {
  const setEditModalVisible = useEmployerReactivationBankListModalsStore((state) => state.setEditModalVisible);
  const setViewModalVisible = useEmployerReactivationBankListModalsStore((state) => state.setViewModalVisible);
  const setCurrentBank = useEmployerReactivationBankListModalsStore((state) => state.setCurrentBank);

  const { banks, isLoading, isEmpty, options, onEditHandler, onViewHandler } = useEmployerReactivationBankList({
    onEdit: () => setEditModalVisible(true),
    onView: () => setViewModalVisible(true),
    setBank: setCurrentBank,
  });

  const handleEdit = (id: string) => {
    onEditHandler(id);
  };

  const handleView = (id: string) => {
    onViewHandler(id);
  };

  return {
    banks,
    isLoading,
    isEmpty,
    options,
    onEdit: handleEdit,
    onView: handleView,
  };
};
